import React from 'react'
import '../../CSS/projects.css'

export default function Projects(props) {

  const projects = [
    {
      title: "Motomate App",
      img: "https://i.ibb.co/rKYh8TCX/motomate-v2-small.jpg",
      desc: "MotoMate is your ultimate digital bike companion available on playstore, designed to help motorcycle owners effortlessly track their service records, mileage, parts changes, fuel logs, and more.",
      buttons: [
        {
          label: "Get from Playstore",
          link: "https://play.google.com/store/apps/details?id=com.anonymous.MotoMate",
          className: "btn-warning",
          show: true
        }
      ],
      onClickModal: true
    },

    {
      title: "BookMyRide",
      img: "https://i.ibb.co/ZTDy52X/image.png",
      desc: "Discover the freedom of the open road with BookMyRide and make your next journey unforgettable. With easy online booking, finding the perfect ride is just a few clicks away.",
      buttons: [
        {
          label: "Github Repository",
          link: "https://github.com/NSugam/book-my-ride-app",
          className: `btn-${props.mode === 'dark' ? 'light' : 'warning'}`
        },
        {
          label: "Live Demo",
          link: "https://bookmyride-frontend.vercel.app/",
          className: "btn-outline-success"
        }
      ]
    },

    {
      title: "RedPanda Shopping",
      img: "https://i.ibb.co/cLsr01d/image.png",
      desc: "A MERN-based project that calculates the amount with interest provided to different individuals, while also allowing users to add information about loans they have taken.",
      buttons: [
        {
          label: "Github Repository",
          link: "https://github.com/NSugam/redpanda-clothing",
          className: `btn-${props.mode === 'dark' ? 'light' : 'warning'}`
        },
        {
          label: "Live Demo (on going... )",
          link: "#",
          className: "btn-outline-success disabled"
        }
      ]
    },

    {
      title: "Realtime Chat App: Socket.io",
      img: "https://i.ibb.co/KccNw7xB/image.png",
      desc: "A MERN-based project that uses socket.io for realtime chatting with the registered user and also stores the messages in database.",
      buttons: [
        {
          label: "Github Repository",
          link: "https://github.com/NSugam/chat-application-socket-mongodb",
          className: `btn-${props.mode === 'dark' ? 'light' : 'warning'}`
        },
        {
          label: "Live Demo (Tunnel)",
          link: "https://chat.neupanesugam.com.np/",
          className: "btn-outline-success"
        }
      ]
    },

    {
      title: "Interest-Book",
      img: "https://i.ibb.co/Qn3kvs1/interest-book.png",
      desc: "A MERN-based project that calculates the amount with interest provided to different individuals, while also allowing users to add information about loans they have taken.",
      buttons: [
        {
          label: "Github Repository",
          link: "https://github.com/NSugam/Interest-book-MERN",
          className: `btn-${props.mode === 'dark' ? 'light' : 'warning'}`
        },
        {
          label: "Live Demo",
          link: "https://interest-book.vercel.app/",
          className: "btn-outline-success"
        }
      ]
    },

    {
      title: "Hotel Bookings",
      img: "https://i.ibb.co/C20fC9G/image.png",
      desc: "This website offers a user-friendly platform to browse and book accommodations with detailed descriptions and reviews.",
      buttons: [
        {
          label: "Github Repository",
          link: "https://github.com/NSugam/internship-homelyhub",
          className: `btn-${props.mode === 'dark' ? 'light' : 'warning'}`
        }
      ]
    },

    {
      title: "Food delivery system",
      img: "https://i.ibb.co/Dwmtk3p/food-delivery.png",
      desc: "Food delivery websites have revolutionized the way we enjoy our favorite meals.",
      buttons: [
        {
          label: "Github Repository",
          link: "https://github.com/NSugam/Food-delivery-system-django",
          className: `btn-${props.mode === 'dark' ? 'light' : 'warning'}`
        }
      ]
    },

    {
      title: "TODO-application",
      img: "https://i.ibb.co/FW2zbff/image.png",
      desc: "This TODO app allows users to add, remove, and update tasks in real-time.",
      buttons: [
        {
          label: "Live Demo",
          link: "https://todo-app-nsugam.vercel.app",
          className: "btn-outline-success"
        }
      ]
    },

    {
      title: "Text Utilities",
      img: "https://i.ibb.co/nwZthyn/image.png",
      desc: "ReactJS Text Case Converter for transforming text between uppercase and lowercase.",
      buttons: [
        {
          label: "Github Repository",
          link: "https://github.com/NSugam/react-TextUtils",
          className: `btn-${props.mode === 'dark' ? 'light' : 'warning'}`
        },
        {
          label: "Live Demo",
          link: "https://react-text-utils-psi.vercel.app/",
          className: "btn-outline-success"
        }
      ]
    },

    {
      title: "My Portfolio",
      img: "https://i.ibb.co/4smRNst/image.png",
      desc: "A curated collection of work that showcases skills, experiences, and accomplishments.",
      buttons: [
        {
          label: "Visit website",
          link: "#home",
          className: "btn-outline-success"
        }
      ]
    },

    {
      title: "My Repositories",
      img: "https://i.ibb.co/5FkDrgw/image.png",
      desc: "GitHub repositories help manage projects with collaboration and version control.",
      buttons: [
        {
          label: "My Repository",
          link: "https://github.com/NSugam",
          className: `btn-${props.mode === 'dark' ? 'light' : 'warning'}`
        }
      ]
    }
  ]

  return (
    <>
      <div
        className='pb-4'
        style={
          props.mode === 'dark'
            ? { backgroundImage: 'url(https://i.ibb.co/nmSkQTC/background.jpg)' }
            : { background: 'linear-gradient(45deg, #00bcd4,#ffeb3b)' }
        }
        data-bs-theme={props.mode}
      >

        <div id="projects" className='madimi-one-regular text-center content-heading-text'>
          Projects
        </div>

        <hr className="w-75 m-auto" />

        <p className='fs-5 text-center mt-3'>
          My Projects are a versatile initiative that brings together practical solutions using technology.
        </p>

        <p className='fs-5 text-center text-danger fw-bold'>
          "Please note that some projects are client-specific, and therefore, not all GitHub repositories may be accessible."
        </p>

        <div className="container d-flex justify-content-center align-items-center text-center mt-5">
          <div className="Projectcontainer d-flex justify-content-center row m-auto user-select-none">

            {projects.map((project, index) => (
              <div
                key={index}
                className={`card d-flex justify-content-center align-items-center col-6 mb-5 mx-5
                ${props.mode === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}`}
                style={{ cursor: project.onClickModal ? 'pointer' : 'default' }}
                onClick={() => {
                  if (project.onClickModal) {
                    const modal = new window.bootstrap.Modal(document.getElementById('motoMateModal'));
                    modal.show();
                  }
                }}
              >

                <div className={`imgBx position-absolute ${props.mode === 'dark' ? 'bg-light' : 'bg-light'}`}>
                  <img src={project.img} alt="Loading..." />
                </div>

                <div className="content overflow-hidden position-absolute">
                  <h3 className='over-the-rainbow-regular'>{project.title}</h3>

                  <p className='ms-3 me-3'>{project.desc}</p>

                  <div className='card-foot mb-auto m-3'>

                    {project.buttons.map((btn, i) => (
                      <a
                        key={i}
                        href={btn.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`btn ${btn.className} d-block mb-2`}
                      >
                        {btn.label}
                      </a>
                    ))}

                  </div>
                </div>

              </div>
            ))}

            <div className="col-sm-6">
              <p className='fw-bold border p-3 rounded-5 mt-3 mx-5'>
                Other Projects will be updated soon...
              </p>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}